import { LOCATION_CHANGE } from 'connected-react-router';
import { handleActions } from 'redux-actions';

import {
  customerFetchError,
  customerFetchResponse,
  customerGetBalance,
  customerGetBilling
} from 'shared/store/modules/customers/actions';

const defaultState = {
  displayName: '',
  isFetching: false,
  isBankAccountVerified: false,
  isOptedInToAutoPayments: null,
  error: null,
  nextPaymentId: null,
  paymentSources: [],
  dashboard: {
    accountActivity: []
  },
  balance: {}
};

export const reducer = handleActions(
  {
    [LOCATION_CHANGE]: state => ({
      ...state,
      isFetching: false
    }),

    [customerFetchResponse]: (state, { payload }) => ({
      ...state,
      ...payload
    }),

    [customerFetchError]: (state, { payload }) => ({
      ...state,
      error: payload.response,
      isFetching: false
    }),

    [customerGetBilling]: (state, { payload }) => ({
      ...state,
      dashboard: payload,
      isFetching: false
    }),

    [customerGetBalance]: (state, { payload }) => ({
      ...state,
      balance: payload,
      isFetching: false
    })
  },

  defaultState
);
